import qc from 'qc'
import gameIframe from '@ps/bridge/iframe/iframe'
import { getNewUniqCopyName } from '@ps/views/workbench/layer-manager/layer'
import { isSquaredUp } from '@ps/bridge/qc/base'
import { getDescendants, getDescendantsText } from '@ps/bridge/qc/node/utils'
import { updateTextNodeLangKeyAfterCloneNode } from '@ps/workbench/layer/text'
import store from '@ps/store'
import { refreshTextStyleByLangConfig } from '@ps/bridge/qc/scripts/language'

/**
 * 克隆节点，并返回新节点
 */
export function cloneNode({
  originalNodes,
  parent,
  index,
}: {
  // 要复制的节点
  originalNodes: qc.Node[]
  // 复制的目标节点
  parent: qc.Node
  index: number
}): qc.Node[] {
  const newNodes: qc.Node[] = []

  for (let i = 0; i < originalNodes.length; i++) {
    const originalNode = originalNodes[i]
    const newNode = gameIframe.qcGame.add.clone(originalNode, parent)
    newNode.name = getNewUniqCopyName(originalNode.name)

    // 处理子节点关联逻辑
    const allChildrenNode = getDescendants(newNode, null, false)
    if (allChildrenNode.length) {
      allChildrenNode.forEach((item) => {
        item.name = getNewUniqCopyName(item.name)
      })
    }

    // 节点带有图片九宫格属性，单独复制属性值
    if (isSquaredUp(newNode)) {
      newNode.borderTop = originalNode.borderTop
      newNode.borderBottom = originalNode.borderBottom
      newNode.borderLeft = originalNode.borderLeft
      newNode.borderRight = originalNode.borderRight
    }

    // 文本节点信息处理
    const texts = getDescendantsText(newNode)
    if (texts && texts.length) {
      texts.forEach((node) => {
        updateTextNodeLangKeyAfterCloneNode(node)
        const adapterResolution =
          store.state.workspace.game.device.adapterResolution
        const lang = store.state.workspace.language.currentLanguage
        // 修改文本的样式后clone文本节点这种情况下，qc引擎底层clone节点后,文本的样式会被重新设置成文本修改前的样式，所以需要用ps.Langugaes里的配置refresh一下
        refreshTextStyleByLangConfig(node, lang, adapterResolution)
      })
    }

    newNode.parent.setChildIndex(newNode, index)
    newNodes.push(newNode)
  }

  return newNodes
}
